/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Checking_StatusInputs */

const en_directory_promotion_checking_status = /** @type {(inputs: Directory_Promotion_Checking_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your account status...`)
};

const zh_directory_promotion_checking_status = /** @type {(inputs: Directory_Promotion_Checking_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在检查账户状态……`)
};

/**
* | output |
* | --- |
* | "Checking your account status..." |
*
* @param {Directory_Promotion_Checking_StatusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_checking_status = /** @type {((inputs?: Directory_Promotion_Checking_StatusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Checking_StatusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_checking_status(inputs)
	return zh_directory_promotion_checking_status(inputs)
});
export { directory_promotion_checking_status as "directory.promotion.checking_status" }